module.exports = __webpack_public_path__ + "static/media/trash-red.fe0724fc.png";